import { ComponentProps, ReactNode, Ref } from 'react'

import { AstraTooltip } from '~/astra'
import { ButtonTag, getColorFromType } from '~/components'
import env from '~/env'

import { type PractitionerActivity, PractitionerActivityDnd } from '../../../PractitionerActivityDnd'
import { draggedChipClassName } from '../../../shared/styles'

type ButtonTagProps = ComponentProps<typeof ButtonTag>

type Props = {
    tooltip?: string
    dragItem?: PractitionerActivity
    colorType: ButtonTagProps['colorType']
    isGrayedOut?: boolean
    whiteText?: boolean
    label?: string
    isLoading?: boolean
    endContent?: ReactNode
    ref?: Ref<HTMLDivElement>
}

export const ActivityTag = ({ ref, tooltip, colorType, whiteText, isLoading, isGrayedOut, label, dragItem, endContent }: Props) => {
    const isDragging = PractitionerActivityDnd.useIsDragging(dragItem)
    const isDraggingStyles = isDragging ? draggedChipClassName : ''
    const grayedOutStyles = isGrayedOut ? 'opacity-30' : ''

    return (
        <div className="inline-flex w-full" ref={ref}>
            <AstraTooltip tooltipContent={!env.VITE_NO_UNSTABLE_EFFECTS ? tooltip : null} noWrapText>
                <PractitionerActivityDnd.Draggable payload={dragItem}>
                    <ButtonTag
                        isLoading={isLoading}
                        tabIndex={-1}
                        colorType={colorType}
                        whiteText={whiteText}
                        fillType="all"
                        style={{ borderColor: `color-mix(in srgb, ${getColorFromType(colorType)} 90%, black)` }}
                        className={`activity-tag !min-w-[20px] overflow-hidden text-clip whitespace-nowrap transition-opacity duration-200 ${isDraggingStyles} ${grayedOutStyles}`}
                        label={label ?? ''}
                        endContent={endContent}
                    />
                </PractitionerActivityDnd.Draggable>
            </AstraTooltip>
        </div>
    )
}
